/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class ResourceDenfinitionServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * API接口查询
     * @param appCode (optional) 服务code
     * @param interfaceName (optional) 接口名称
     * @return OK
     */
    queryResourceInfo(appCode: string | null | undefined, interfaceName: string | null | undefined): Promise<ResourceDefinition[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/masterlink-permission-resource')+ "/api-resource?";
        if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&"; 
        if (interfaceName !== undefined)
            url_ += "interfaceName=" + encodeURIComponent("" + interfaceName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryResourceInfo(_response);
        });
    }

    protected processQueryResourceInfo(response: AxiosResponse): Promise<ResourceDefinition[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceDefinition.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ResourceDefinition[]>(<any>null);
    }

    /**
     * 服务模块查询
     * @param appCode appCode
     * @return OK
     */
    selectResourceDefinitionByAppCode(appCode: string): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/masterlink-permission-resource')+ "/api-resource/service/{appCode}";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined.");
        url_ = url_.replace("{appCode}", encodeURIComponent("" + appCode)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSelectResourceDefinitionByAppCode(_response);
        });
    }

    protected processSelectResourceDefinitionByAppCode(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

/** ResourceDefinition对象 */
export class ResourceDefinition implements IResourceDefinition {
    /** 应用的标识 */
    appCode!: string | undefined;
    /** 控制器类名称 */
    className!: string | undefined;
    /** 资源的标识 */
    code!: string | undefined;
    /** 资源添加日期 */
    createTime!: Date | undefined;
    /** http请求方法 */
    httpMethod!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 初始化资源的机器的ip地址 */
    ipAddress!: string | undefined;
    /** 是否是菜单 */
    menuFlag!: boolean | undefined;
    /** 控制器中的方法名称 */
    methodName!: string | undefined;
    /** 资源所属模块 */
    modularCode!: string | undefined;
    /** 模块名称 */
    modularName!: string | undefined;
    /** 资源名称 */
    name!: string | undefined;
    /** 是否需要登录 */
    requiredLogin!: boolean | undefined;
    /** 是否需要鉴权 */
    requiredPermission!: boolean | undefined;
    /** 资源的请求路径 */
    url!: string | undefined;
    /** API版本 */
    version!: string | undefined;

    constructor(data?: IResourceDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.className = data["className"];
            this.code = data["code"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.httpMethod = data["httpMethod"];
            this.id = data["id"];
            this.ipAddress = data["ipAddress"];
            this.menuFlag = data["menuFlag"];
            this.methodName = data["methodName"];
            this.modularCode = data["modularCode"];
            this.modularName = data["modularName"];
            this.name = data["name"];
            this.requiredLogin = data["requiredLogin"];
            this.requiredPermission = data["requiredPermission"];
            this.url = data["url"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): ResourceDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["className"] = this.className;
        data["code"] = this.code;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["httpMethod"] = this.httpMethod;
        data["id"] = this.id;
        data["ipAddress"] = this.ipAddress;
        data["menuFlag"] = this.menuFlag;
        data["methodName"] = this.methodName;
        data["modularCode"] = this.modularCode;
        data["modularName"] = this.modularName;
        data["name"] = this.name;
        data["requiredLogin"] = this.requiredLogin;
        data["requiredPermission"] = this.requiredPermission;
        data["url"] = this.url;
        data["version"] = this.version;
        return data; 
    }
}

/** ResourceDefinition对象 */
export interface IResourceDefinition {
    /** 应用的标识 */
    appCode: string | undefined;
    /** 控制器类名称 */
    className: string | undefined;
    /** 资源的标识 */
    code: string | undefined;
    /** 资源添加日期 */
    createTime: Date | undefined;
    /** http请求方法 */
    httpMethod: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 初始化资源的机器的ip地址 */
    ipAddress: string | undefined;
    /** 是否是菜单 */
    menuFlag: boolean | undefined;
    /** 控制器中的方法名称 */
    methodName: string | undefined;
    /** 资源所属模块 */
    modularCode: string | undefined;
    /** 模块名称 */
    modularName: string | undefined;
    /** 资源名称 */
    name: string | undefined;
    /** 是否需要登录 */
    requiredLogin: boolean | undefined;
    /** 是否需要鉴权 */
    requiredPermission: boolean | undefined;
    /** 资源的请求路径 */
    url: string | undefined;
    /** API版本 */
    version: string | undefined;
}